if (!customElements.get('form-validation')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
    }

    getErrorSpan(input) {
      const formRow = input.closest('.form-row, .form-row--double, .field');
      if (!formRow) return null;
      return formRow.querySelector('[data-error]');
    }

    toggleErrorMessage(input) {
      const errorSpan = this.getErrorSpan(input);

      if (!errorSpan) return;

      if (!input.validity.valid) {
        if (input.validity.valueMissing) {
          errorSpan.textContent = 'This field is required.';
        } else if (input.type === 'email') {
          errorSpan.textContent = 'Please enter a valid email address.';
        } else {
          errorSpan.textContent = 'Please enter a valid value.';
        }
      }

      errorSpan.classList.toggle('hidden', input.validity.valid);
      errorSpan.classList.toggle('has-error', !input.validity.valid);
    }
    setFieldValidity(input) {
      const isValid = input.validity.valid;

      input.setAttribute('aria-invalid', !isValid);
      input.classList.toggle('has-error', !isValid);

      let errorSpan = this.getErrorSpan(input);

      if (!errorSpan) {
        const field = input.closest('.field');

        if (field) {
          errorSpan = document.createElement('span');
          errorSpan.setAttribute('data-error', '');
          errorSpan.style.cssText =
            'color:red;font-size:0.85em;display:block;margin-top:4px;';

          field.appendChild(errorSpan);
        }
      }

      if (errorSpan) {
        if (!isValid) {
          errorSpan.textContent = input.validity.valueMissing
            ? 'This field is required.'
            : input.type === 'email'
            ? 'Please enter a valid email address.'
            : 'Please enter a valid value.';

          errorSpan.classList.remove('hidden');
        } else {
          errorSpan.classList.add('hidden');
        }
      }
    }

    clearFieldError(input) {
      input.removeAttribute('aria-invalid');
      input.classList.remove('has-error');
      const errorSpan = this.getErrorSpan(input);
      if (errorSpan) {
        errorSpan.classList.add('hidden');
        errorSpan.classList.remove('has-error');
      }
    }

    handleSubmit(event) {
      event.preventDefault();

      let firstInvalid = null;

      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;
        if (input.type === 'hidden' || input.type === 'submit') continue;

        if (!input.validity.valid) {
          // Error span create/show karo
          const field = input.closest('.field');
          if (field) {
            let errorSpan = field.querySelector('[data-error]');
            if (!errorSpan) {
              errorSpan = document.createElement('span');
              errorSpan.setAttribute('data-error', '');
              errorSpan.style.cssText = 'color:red; font-size:0.85em; display:block; margin-top:4px;';
              field.appendChild(errorSpan);
            }
            errorSpan.textContent = input.validity.valueMissing
              ? 'This field is required.'
              : input.type === 'email'
              ? 'Please enter a valid email address.'
              : 'Please enter a valid value.';
            errorSpan.classList.remove('hidden');
          }
          input.classList.add('has-error');
          input.setAttribute('aria-invalid', 'true');
          if (!firstInvalid) firstInvalid = input;
        }
      }

      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      this.form.submit();
    }

    setEventHandlers() {
      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        input.addEventListener('invalid', event => {
          event.preventDefault();
          this.setFieldValidity(input);
        });

        ['input', 'change'].forEach(eventName => {
          input.addEventListener(eventName, () => {
            this.setFieldValidity(input);
          });
        });

        input.addEventListener('blur', () => {
          this.setFieldValidity(input);
        });
      }
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.setEventHandlers();
    }
  }

  customElements.define('form-validation', FormValidation);
}